<template>
  <select-artist
    :is-shown="isShown"
    :selected-ids="selectedIds"
    :excluded-ids="excludedIds"
    modal-name="selectFeaturingArtist"
    modal-class="select-featuring-artist-modal"
    title="Featuringアーティスト選択"
    :artist-type="1"
    :kana-optional="true"
    @close="onClose"
    @select="onSelect"/>
</template>

<script>
import SelectArtist from './SelectArtist'

export default {
  name: 'SelectFeaturingArtist',
  components: { SelectArtist },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    excludedIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSelect(artists) {
      this.$emit('select', artists)
    },
  },
}
</script>
